export const NAME = 'logInData';
const SET_USER_INFO = `SET_USER_INFO_${NAME}`;

export const setLogInUserInfo = (data) => {
	return {
		type: SET_USER_INFO,
		payload: data,
	};
};

const ACTION_MAP = {
	[SET_USER_INFO]: (state, action) => {
		if (!action.payload) return { ...initialState };
		return {
			...state,
			user: {
				...state.user,
				...action.payload,
			},
		};
	},
};

const initialState = {
	user: {},
};

export const reducer = (state = initialState, action) => {
	const actionFunc = ACTION_MAP[action.type];

	return actionFunc ? actionFunc(state, action) : state;
};
